import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';
import { CommonProvider } from '../common/common.provider';
import { AuthMicrosoftDefaultProvider, AuthMicrosoftProvider } from './auth-microsoft.provider';

@NgModule({
  providers: angularProvidersBuilder({
    provide: AuthMicrosoftProvider,
    deps: [CommonProvider],
    useFactory: (common: CommonProvider) => new AuthMicrosoftDefaultProvider(common, window),
  }).build(),
})
export class AuthMicrosoftProviderModule {}
